module.exports = __webpack_public_path__ + "static/media/logo usos y color-03.83e2086c.png";